import { ActionType } from 'app/store/actionTypes';
import { ActionsUnion, createAction } from 'app/store/helpers';
import {
  BonusPayoutCaseActionPayload,
  BonusPayoutSetActionPayload,
  BonusPayoutVerificationActionPayload,
} from './actionPayload.interfaces';

export const BonusPayoutActions = {
  markPathAsAnonymous: () => createAction(ActionType.MARK_PATH_AS_ANONYMOUS),
  setBonusPayout: (payload: BonusPayoutSetActionPayload) =>
    createAction(ActionType.SET_BONUS_PAYOUT, payload),
  setBonusCase: (payload: BonusPayoutCaseActionPayload) =>
    createAction(ActionType.SET_BONUS_CASE, payload),
  setVerificationData: (payload: BonusPayoutVerificationActionPayload) =>
    createAction(ActionType.SET_VERIFICATION_DATA, payload),
  setProcessId: (processId: string) =>
    createAction(ActionType.SET_PROCESS_ID, { processId }),
  setPolicyRecoveryKey: (policyRecoveryKey: string) =>
    createAction(ActionType.SET_POLICY_RECOVERY_KEY, { policyRecoveryKey }),
  setBonusExpireDate: (payload: string) =>
    createAction(ActionType.SET_BONUS_EXPIRE_DATE, payload),
  clearBonusPayout: () => createAction(ActionType.CLEAR_BONUS_PAYOUT),
};

export type BonusPayoutActionsType = ActionsUnion<typeof BonusPayoutActions>;
